const initialState = {
  loading: null,
  data: null,
  error: [null, null],
  filters: {
    dateStart: new Date(),
    dateEnd: new Date(),
    limit: 10,
  },
};

export default initialState;
